import { Sidebar } from '@/components/Sidebar/Sidebar';
import { TabBar } from '@/components/Tabs/TabBar';
import { Viewer3D } from '@/components/Viewer/Viewer3D';
import { ProfileInspector } from '@/components/ProfileInspector/ProfileInspector';
import { ModelInfoPanel } from '@/components/ModelInfo/ModelInfoPanel';
import { LibraryPanel } from '@/components/Library/LibraryPanel';
import { useAppStore } from '@/state/store';

export default function App() {
  const activeTab = useAppStore((s) => s.activeTab);

  return (
    <div className="app-shell">
      <Sidebar />
      <div className="main-area">
        <TabBar />
        <div className="tab-panel">
          {/* All tabs stay mounted so the 3D scene/WebGL context and
             graph state are never torn down when switching tabs — only
             visibility toggles. This also keeps export capture instant. */}
          <div style={{ position: 'absolute', inset: 0, display: activeTab === 'viewer' ? 'block' : 'none' }}>
            <Viewer3D />
          </div>
          <div style={{ position: 'absolute', inset: 0, display: activeTab === 'inspector' ? 'block' : 'none' }}>
            <ProfileInspector />
          </div>
          <div style={{ position: 'absolute', inset: 0, display: activeTab === 'info' ? 'block' : 'none' }}>
            <ModelInfoPanel />
          </div>
          <div style={{ position: 'absolute', inset: 0, display: activeTab === 'library' ? 'block' : 'none' }}>
            <LibraryPanel />
          </div>
        </div>
      </div>
    </div>
  );
}
